//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import OrderService from "@/api/orderService";
export default {
  data() {
    return {
      productImgUrl: '',
      trackingNumber:'',
      expName: "",
      deliverystatusName: "",
      logo: "",
      list: []
    };
  },
  computed: {

  },
  mounted() {
    this.productImgUrl = this.$route.query.productImgUrl;
    this.trackingNumber = this.$route.query.trackingNumber;
    this.query(this.trackingNumber);
  },
  methods: {
    lineColor(color,index){
      let i;
      this.list.forEach((item,j)=>{
        if(item.color){
          i = j
        }
      })
      if(color&&i!=index){
        return color
      }
    },
    /**
     * 查询提货记录
     */
    query(trackingNumber) {
      OrderService.traceQuery(
        trackingNumber
      )
        .then((result) => {
          let res = result.data;
          this.list = res.result.list;
          this.expName = res.result.expName;
          this.logo = res.result.logo;
          this.deliverystatusName = res.result.deliverystatusName;
        })
        .catch((err) => {
          this.$vux.toast.text(err.msg);
        });
    },
  },
  components: {

  },
};



// WEBPACK FOOTER //
// ./src/views/inventory/logisticsRecord.vue